import * as React from 'react'
import styled from 'styled-components'
import { Icon } from '@ally/metronome-ui'
import { AdobeTile } from '../types'
import { ADOBE_ICON_MAP } from '../constants'
import { iconBgColor } from '../utils'

interface ComponentProps {
  tileData: AdobeTile
  alignment?: AdobeIconAlignment
}

export type AdobeIconAlignment =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'baseline'
  | 'stretch'

const IconWrapper = styled.span<{ alignSelf: AdobeIconAlignment }>`
  ${({ color, alignSelf }): string => {
    return `
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${color};
    border-radius: 50%;
    height: 50px;
    min-width: 50px;
    align-self: ${alignSelf};
  `
  }}
`

const AdobeIcon: React.FC<ComponentProps> = ({
  tileData,
  alignment = 'flex-start',
}) => {
  const adobeIcon = ADOBE_ICON_MAP[tileData.iconName]

  return adobeIcon ? (
    <IconWrapper
      color={iconBgColor(tileData.lobName)}
      alignSelf={alignment}
      data-testid="adobe-icon"
    >
      <Icon
        icon={adobeIcon}
        unsupportedCustomWidth={28}
        unsupportedCustomHeight={28}
        fill="white"
        ariaHidden
      />
    </IconWrapper>
  ) : null
}

export default AdobeIcon
